


import {defineComponent, PropType} from "@vue/composition-api";

export default defineComponent({
  name: "ResultDetails",
  props: {
    phoneNumbers: {type: [] as PropType<String[]>, default: [], required: true},
    emailAddresses: {type: [] as PropType<String[]>, default: [], required: true},
    rooms: {type: String}
  }
})
